"use strict";

exports.__esModule = true;
exports.getPoolId = getPoolId;
var _sdkCore = require("@acala-network/sdk-core");
function getPoolId(pool) {
  if (pool.isDex) {
    return `dex-${(0, _sdkCore.forceToCurrencyName)(pool.asDex)}`;
  }
  if (pool.isLoans) {
    return `loans-${(0, _sdkCore.forceToCurrencyName)(pool.asLoans)}`;
  }
  return 'unknown';
}